import React from 'react'

const LoadingOverlay = ({ text, style }) => {
  return (
    <div
      className="k-i-loading"
      style={{
        position: 'absolute',
        zIndex: 1,
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'rgba(20, 40, 70, 0.4)',
        textAlign: 'center',
        padding: 'auto',
        ...style,
      }}
    ></div>
  )
}

export default LoadingOverlay
